// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirmEmail_link__3itHR {\n  color: blue;\n  text-decoration: underline;\n  margin-left: 4px;\n  display: inline;\n  cursor: pointer; }\n  .confirmEmail_link__3itHR:hover {\n    color: #4545ce; }\n", ""]);
// Exports
exports.locals = {
	"link": "confirmEmail_link__3itHR"
};
module.exports = exports;
